module.exports = __webpack_public_path__ + "images/emoji/doughnut.527ef22ca28627236056.png";